// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"5e38ff03","61":"2a21d27e","66":"6edebf7b","120":"885612b1","876":"a097a166"}[chunkId] + ".chunk.js";
};